<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="商品分类：">
        <el-cascader v-model="categorizeIdArr" :options="categorizeOptions" :props="{ checkStrictly: true , label: 'name',value: 'id',children: 'child'}" clearable size="small"></el-cascader>

      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        categorizeId: ''
      },
      categorizeIdArr: [],
      categorizeOptions: [],  //商品分类
    }
  },
  created() {
    this.getSelectOptions()
  },
  methods: {
    getSelectOptions() {
      sysGoodsCategorizeApi.fetchTreeList({ pageNo: 1, pageSize: 1000, goodsAreaIds: +this.isIntegral ? '2' : '3,4,5', isEnable: true }).then(({ data }) => {
        this.categorizeOptions = this.formatCascaderData(data.list)
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.query.categorizeId = this.categorizeIdArr && this.categorizeIdArr.length > 0 ? this.categorizeIdArr[this.categorizeIdArr.length - 1] : undefined
      this.query.areaIdList = +this.isIntegral ? '2' : '3,4,5'
      this.query.selTimeType = 1
      return this.$common.confirm('是否确认导出')
        .then(() => sysGoodsApi.exportExcel2(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>